import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN ExpertBio variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */

/**
 * Container styles for the expert bio wrapper
 */
export const expertBioContainerVariants = cva('flex rounded-xl', {
  variants: {
    layout: {
      vertical: 'flex-col gap-sm w-76 h-fit',
      horizontal: 'flex-row gap-lg items-start h-fit w-full',
    },
    background: {
      none: 'bg-transparent',
      white: 'p-xl',
      shadow: 'p-xl shadow-md',
    },
  },
  defaultVariants: {
    layout: 'vertical',
    background: 'none',
  },
});

/**
 * Image styles based on layout variant
 */
export const expertBioImageVariants = cva('object-cover', {
  variants: {
    layout: {
      vertical: 'w-full h-auto',

      horizontal: 'w-36 h-36 flex-shrink-0',
    },
  },
  defaultVariants: {
    layout: 'vertical',
  },
});

export type ExpertBioContainerVariantProps = VariantProps<
  typeof expertBioContainerVariants
>;
export type ExpertBioImageVariantProps = VariantProps<
  typeof expertBioImageVariants
>;
